import "./Livestat.css"

const Livestat = ({ statistics }) => {

    const parseValue = (val) => {
        if (val === null || val === undefined) return 0;
        if (typeof val === "string") {
            return parseFloat(val.replace("%", "")) || 0;
        }
        return Number(val) || 0;
    };

    const getWidth = (left, right) => {
        const total = Math.abs(left) + Math.abs(right) || 1;
        return {
            left: (Math.abs(left) / total) * 100,
            right: (Math.abs(right) / total) * 100
        };
    };

    const homeStats = statistics?.[0]?.statistics || [];
    const awayStats = statistics?.[1]?.statistics || [];

    return (
        <div className="livestatWrapper">

            {homeStats.map((homeStat, index) => {

                const awayStat = awayStats[index] || {};

                const leftRaw = homeStat?.value;
                const rightRaw = awayStat?.value;

                const leftValue = parseValue(leftRaw);
                const rightValue = parseValue(rightRaw);

                const width = getWidth(leftValue, rightValue);

                /* determine winner */
                const leftIsHigher = leftValue > rightValue;
                const rightIsHigher = rightValue > leftValue;

                return (
                    <div className="statcon" key={index}>
                        <div className="stathead">
                            <p>{leftRaw ?? 0}</p>
                            <p>{homeStat?.type}</p>
                            <p>{rightRaw ?? 0}</p>
                        </div>

                        <div>
                            <nav className="left" >
                                <span
                                    style={{
                                        width: `${width.left}%`,
                                        background: leftIsHigher
                                            ? "#0C358B"
                                            : "#777575",
                                        filter: leftIsHigher
                                            ? "blur(0.2px)"
                                            : "none"
                                    }}
                                ></span>
                            </nav>

                            <nav className="right">
                                <span
                                    style={{
                                        width: `${width.right}%`,
                                        background: rightIsHigher
                                            ? "#0C358B"
                                            : "#777575",
                                        filter: rightIsHigher
                                            ? "blur(0.2px)"
                                            : "none"
                                    }}
                                ></span>
                            </nav>
                        </div>
                    </div>
                );

            })}

        </div>
    );
};

export default Livestat;